<!-- start banner Area -->
<section class="top-banner">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="">Modèle CV</h1>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start blog-posts Area -->
<section class="">
  <div class="">
    <div class="row">
      <div class="" style="margin: auto; color: black;">
        <!-- Content of menu 'rediger-cv' -->
        <div class="single-post" *ngIf="submenu == 'rediger-cv'">
          <h1>
            REDIGER UN CV
          </h1>
          <p>

          </p>
        </div>

        <!-- Content of menu 'modele-cv-consultant' -->
        <div class="" *ngIf="submenu == 'modele-cv-consultant'">
          <section class="cv">

            <div class="container">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-4">
                  <div class="box-pdf" style="">
                    <img class="img-pdf" style="margin-right: 10px;" src="assets/img/cv/icon_word.png">
                    <div>
                      <h4>Modèle CV Consultant</h4>
                      <a href="assets/docs/Modele-CV-Consultant.docx" class="btn btn-submit-second"> Télécharger</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>
        </div>

        <!-- Content of menu 'modele-cv-emploi' -->
        <div class="" *ngIf="submenu == 'modele-cv-emploi'">
          <section class="cv">
            <div class="container">
              <div class="row">
                <div class="col-lg-8">
                  <div class="row">
                    <div class="col-12 col-sm-6 col-lg-6">
                      <div class="box-pdf" style="">
                        <img class="img-pdf" style="margin-right: 10px;" src="assets/img/cv/icon_word.png">
                        <div>
                          <h4>Modèle CV Emploi 1</h4>
                          <a href="assets/docs/Modele-CV-Emploi-0.docx" class="btn btn-submit-second"> Télécharger</a>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                      <div class="box-pdf" style="">
                        <img class="img-pdf" style="margin-right: 10px;" src="assets/img/cv/icon_word.png">
                        <div>
                          <h4>Modèle CV Emploi 2</h4>
                          <a href="assets/docs/Modele-CV-Emploi-1.docx" class="btn btn-submit-second"> Télécharger</a>
                        </div>
                      </div>

                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                      <div class="box-pdf" style="">
                        <img class="img-pdf" style="margin-right: 10px;" src="assets/img/cv/icon_word.png">
                        <div>
                          <h4>Modèle CV Emploi 3</h4>
                          <a href="assets/docs/Modele-CV-Emploi-2.docx" class="btn btn-submit-second"> Télécharger</a>
                        </div>
                      </div>

                    </div>
                    <div class="col-12 col-sm-6 col-lg-6">
                      <div class="box-pdf" style="">
                        <img class="img-pdf" style="margin-right: 10px;" src="assets/img/cv/icon_word.png">
                        <div>
                          <h4>Modèle CV Emploi 4</h4>
                          <a href="assets/docs/Modele-CV-Emploi-3.docx" class="btn btn-submit-second"> Télécharger</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <a href="https://www.livecareer.fr/lp/fr/lfrrsmlp07.aspx?utm_source=google&utm_medium=display&utm_campaign=160330623&utm_term=&network=d&device=c&adposition=&adgroupid=12227553423&placement=www.findajobinafrica.com&gclid=Cj0KCQjwlPWgBhDHARIsAH2xdNcTs03rz0PmgL9HpGfLmYZ8ufxmndmvL2SjuN5m2tq0OEwomfAT7OAaAsZwEALw_wcB"
                        class="btn btn-secondary" style="width: 100%;" role="button " target="_blank"><img class=""
                          width="40" height="50" src="assets/img/pdf.png">Modèles de CV
                        gratuits</a>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <a href="https://www.livecareer.fr/lp/fr/lfrrsmlp07.aspx?utm_source=google&utm_medium=display&utm_campaign=160330623&utm_term=&network=d&device=c&adposition=&adgroupid=12227553423&placement=www.findajobinafrica.com&gclid=Cj0KCQjwlPWgBhDHARIsAH2xdNcTs03rz0PmgL9HpGfLmYZ8ufxmndmvL2SjuN5m2tq0OEwomfAT7OAaAsZwEALw_wcB"
                        class="btn btn-secondary" style="width: 100%;" role="button" target="_blank"><img class=""
                          width="40" height="50" src="assets/img/pdf.png">Exemples de CV
                        gratuits</a>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <a href="https://www.livecareer.fr/lp/fr/lfrrsmlp07.aspx?utm_source=google&utm_medium=display&utm_campaign=160330623&utm_term=&network=d&device=c&adposition=&adgroupid=12227553423&placement=www.findajobinafrica.com&gclid=Cj0KCQjwlPWgBhDHARIsAH2xdNcTs03rz0PmgL9HpGfLmYZ8ufxmndmvL2SjuN5m2tq0OEwomfAT7OAaAsZwEALw_wcB"
                        class="btn btn-secondary" style="width: 100%;" role="button" target="_blank"><img class=""
                          width="40" height="50" src="assets/img/pdf.png">Mise en forme de CV
                      </a>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-body">
                      <a href="https://www.livecareer.fr/lp/fr/lfrrsmlp07.aspx?utm_source=google&utm_medium=display&utm_campaign=160330623&utm_term=&network=d&device=c&adposition=&adgroupid=12227553423&placement=www.findajobinafrica.com&gclid=Cj0KCQjwlPWgBhDHARIsAH2xdNcTs03rz0PmgL9HpGfLmYZ8ufxmndmvL2SjuN5m2tq0OEwomfAT7OAaAsZwEALw_wcB"
                        target="_blank" class="btn btn-secondary" style="width: 100%;" role="button"><img class=""
                          width="40" height="50" src="assets/img/pdf.png">Outil CV builder
                        gratuit</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>
          <section
            style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
            <div class="container">
              <app-autresites></app-autresites>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <!-- <app-confiance></app-confiance> -->
</section>
<!-- End blog-posts Area -->